/**
 * Class representing a loading indicator
 */
define(['jquery'], function ($) {
   "use strict";

   return function (jElList, fnOnFinish) {
      var m_jElList = (typeof jElList === "string") ? $(jElList) : jElList,
         m_jLoadingList = $(),
         m_jWindow = $(window),

         /**
          * Position the loading animation so it's on the background and close to the
          * center of the window view
          */
         positionAnim = function () {
            m_jLoadingList.each(function (i, elLoading) {
               var jLoading = $(elLoading),
                  jAnim = jLoading.data('anim'),
                  iMaxHeight = jLoading.height() - jAnim.height(),
                  iHeight = m_jWindow.height(),
                  iScrollTop = m_jWindow.scrollTop(),
                  iAbsoluteCenter = iScrollTop + (iHeight / 2),
                  iCenter = iAbsoluteCenter - jLoading.offset().top;

               if (iCenter < 0) {
                  iCenter = 0;
               } else if (iCenter > iMaxHeight) {
                  iCenter = iMaxHeight;
               }

               jAnim.css({
                  top: iCenter
               });
            });
         },

         /**
          * Fire it up
          */
         initialize = function () {
            m_jElList.each(function (i, el) {
               var jEl = $(el),
                  jLoading = $('<div class="whiteWashedBackground" />'),
                  jAnim = $('<div class="loadingAnimation" />'),
                  strPosition = jEl.css('position');

               if (strPosition !== 'absolute') {
                  // Save the old position type
                  jEl.data('oldPosition.loadingIndicator', strPosition);

                  // Modify the position so the loading indicator can
                  // accurately display
                  jEl.css({
                     position: 'relative'
                  });
               }

               jLoading.data('anim', jAnim);

               jLoading.append(jAnim);
               jEl.append(jLoading);

               m_jLoadingList = m_jLoadingList.add(jLoading);
            });

            m_jWindow.on('scroll', positionAnim);
            positionAnim();

            m_jLoadingList.css({
               opacity: 0
            });

            m_jLoadingList.animate({
               opacity: 0.8
            });
         };

      initialize();

      this.destroy = function () {
         m_jWindow.unbind('scroll', positionAnim);
         m_jLoadingList.animate({
            opacity: 0
         }, function () {
            m_jLoadingList.remove();

            m_jElList.each(function (i, el) {
               var jEl = $(el),
                  strOldPos = jEl.data('oldPosition.loadingIndicator');

               if (strOldPos !== undefined) {
                  // Restore the old position type
                  jEl.css({
                     position: strOldPos
                  });
               }
            });

            if (fnOnFinish) {
               fnOnFinish();
            }
         });
      };
   };
});
